import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { InjectedFormProps } from 'redux-form';
import MTADeclarationForm from '../CoverDetails/scenes/MTADeclarationForm';

interface IAMTUpsellProps extends InjectedFormProps<any> {
  match: any;
}

class AMTUpsell extends React.Component<IAMTUpsellProps, any> {

  render() {
    return (
      <>
        <MTADeclarationForm redirectUrl={`/account/make-a-change/mta/change-trip-type`}/>
      </>
    );
  }
}

export default flow([
  connect(
    (state: IStore) => {
      return {
        mta: state.mta,
      };
    },
  ),
])(AMTUpsell);
